import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

export interface EmptyStateProps {
  title: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ title, description, icon, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'border-border-strong/25 bg-surface-subtle/40 flex flex-col items-center justify-center rounded-2xl border border-dashed px-6 py-14 text-center',
        className,
      )}
    >
      {icon && (
        <div className="bg-gold-50 text-gold-500 ring-gold-100 mb-4 grid h-14 w-14 place-items-center rounded-2xl ring-1 ring-inset">
          {icon}
        </div>
      )}
      <p className="text-ink text-[15px] font-semibold tracking-tight">{title}</p>
      {description && (
        <p className="text-ink-muted mt-1.5 max-w-md text-sm leading-relaxed">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
